// extracted by mini-css-extract-plugin
export default {"container":"CardHeader_container__891ON","my_space_button":"CardHeader_my_space_button__2OHH8","active_link":"CardHeader_active_link__zKkYH"};